import api from "@/api";
import i18n from "@/i18n";

const { t } = i18n.global;

export default {
  state: {
    selectedPolicyService: {},
  },
  getters: {
    selectedPolicyService: (state) => state.selectedPolicyService,
  },
  mutations: {
    setSelectedPolicyService: (state, data) => {
      state.selectedPolicyService = data;
    },
  },
  actions: {
    deletePolicyService: async ({ commit }, serviceId) => {
      try {
        await api({ requiresAuth: true }).delete(
          `/v1/policy-services/${serviceId}`
        );
        commit("setToast", {
          display: true,
          type: "success",
          message: t("messages.policyServiceDeletedSuccessfully")
        }, { root: true });
      } catch (err) {
        commit("setToast", {
          display: true,
          type: "error",
          message: err.response?.data?.message || t("messages.failedToDeletePolicyService")
        }, { root: true });
        throw err;
      }
    },

    updatePolicyServiceInterval: async ({ commit }, { serviceId, intervalId }) => {
      try {
        await api({ requiresAuth: true }).patch(
          `/v1/policy-services/${serviceId}/intervals`,
          {
            premium_interval_id: intervalId,
          }
        );
        commit("setToast", {
          display: true,
          type: "success",
          message: t("messages.intervalUpdatedSuccessfully")
        }, { root: true });
      } catch (err) {
        commit("setToast", {
          display: true,
          type: "error",
          message: err.response?.data?.message || t("messages.failedToUpdateInterval")
        }, { root: true });
        throw err;
      }
    },

    updatePolicyServiceStartDate: async ({ commit }, { serviceId, date }) => {
      try {
        await api({ requiresAuth: true }).patch(
          `/v1/policy-services/${serviceId}/startDate`,
          {
            start_date: date,
          }
        );
        commit("setToast", {
          display: true,
          type: "success",
          message: t("messages.startDateUpdatedSuccessfully")
        }, { root: true });
      } catch (err) {
        commit("setToast", {
          display: true,
          type: "error",
          message: err.response?.data?.message || t("messages.failedToUpdateStartDate")
        }, { root: true });
        throw err;
      }
    },

    updatePolicyServiceEndDate: async ({ commit }, { serviceId, date }) => {
      try {
        await api({ requiresAuth: true }).patch(
          `/v1/policy-services/${serviceId}/endDate`,
          {
            end_date: date,
          }
        );
        commit("setToast", {
          display: true,
          type: "success",
          message: t("messages.endDateUpdatedSuccessfully")
        }, { root: true });
      } catch (err) {
        commit("setToast", {
          display: true,
          type: "error",
          message: err.response?.data?.message || t("messages.failedToUpdateEndDate")
        }, { root: true });
        throw err;
      }
    },

    updatePolicyServiceBruttoPremium: async ({ commit }, { serviceId, bruttoPremium }) => {
      try {
        await api({ requiresAuth: true }).patch(
          `/v1/policy-services/${serviceId}/premium`,
          {
            premium: bruttoPremium,
          }
        );
        commit("setToast", {
          display: true,
          type: "success",
          message: t("messages.premiumUpdatedSuccessfully")
        }, { root: true });
      } catch (err) {
        commit("setToast", {
          display: true,
          type: "error",
          message: err.response?.data?.message || t("messages.failedToUpdatePremium")
        }, { root: true });
        throw err;
      }
    },
  },
};
